module.exports = __webpack_public_path__ + "img/Ecuador.66edcdc3.svg";